import { Button, Card, Col, Divider, Flex, Row, Space } from "antd";
import { useTranslation } from "react-i18next";
import { formatBankAccountNo } from "utils/formatter/formatCommon";
import { ReactComponent as DownloadIcon } from "../../../assets/icon/downloadIcon.svg";
import { ReactComponent as EyeHideIcon } from "../../../assets/icon/eyeClose.svg";
import { ReactComponent as EyeIcon } from "../../../assets/icon/eyeIcon.svg";
import EmployeeSalaryDownloadModal from "./EmployeeSalaryDownloadModal";


function EmployeeSalaryInfoComponent({
    isVisible = false,
    setIsVisible = () => { },
    currentSalary = {},
    bankGroupType = [],
    showModal = () => { },
    isModalDownloadOpen,
    setIsModalDownloadOpen,
    payrollPeriodByEmployee = {},
    payrollPeriodYear = [],
    monthList = [],
    setSelectedMonth = () => { },
    filteredPayrollPeriod = () => { },
    getPaySlipReportByPayrollPeriodFile = () => { },
    setSelectedYear = () => { },
    selectedYear = () => { },
    pageForm = "EMPLOYEE",
    permissions,
    isDownloading = false
}) {
    const { t, i18n } = useTranslation();

    const handleToggleVisibility = () => {
        setIsVisible(prevState => !prevState);
    };

    const checkDisableVisible = () => {
        return permissions?.VISIBLE ? false : true
    }

    return (
        <Card style={{ border: "1px solid #EAECF0", borderRadius: "8px" }}>
            <Space direction="vertical" style={{ width: "100%" }} size={16}>
                <EmployeeSalaryDownloadModal
                    isModalDownloadOpen={isModalDownloadOpen}
                    setIsModalDownloadOpen={setIsModalDownloadOpen}
                    payrollPeriodByEmployee={payrollPeriodByEmployee}
                    payrollPeriodYear={payrollPeriodYear}
                    monthList={monthList}
                    setSelectedMonth={setSelectedMonth}
                    filteredPayrollPeriod={filteredPayrollPeriod}
                    getPaySlipReportByPayrollPeriodFile={getPaySlipReportByPayrollPeriodFile}
                    selectedYear={selectedYear}
                    setSelectedYear={setSelectedYear}
                    isDownloading={isDownloading}
                />
                <Row justify="space-between" align="middle">
                    <span style={{ fontSize: "16px", fontWeight: "bold" }}>{t("employee.salary.header")}</span>
                    <Flex gap={10}>
                        <Button style={{ width: "max-content", height: "40px", borderRadius: "8px", padding: "10px 16px" }}
                            icon={isVisible ? <EyeHideIcon /> : <EyeIcon />}
                            onClick={handleToggleVisibility}
                            disabled={checkDisableVisible()}
                        />

                        <Button
                            type="primary"
                            style={{ width: "max-content", height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)", color: "white" }}
                            onClick={showModal}
                        >
                            <Flex align="center" justify="center" gap={8}>
                                <DownloadIcon />
                                {t("employee.salary.download_slip").toUpperCase()}
                            </Flex>
                        </Button>
                    </Flex>
                </Row>

                <Divider style={{ borderColor: "#EAECF0", borderWidth: "1px" }} />

                <Flex vertical style={{ rowGap: "16px" }}>
                    <Flex vertical style={{ gap: "12px" }}>
                        <span style={{ fontSize: "16px", color: "#667085" }}>{t('SalarySalary.payment-methods')}</span>
                        {currentSalary?.paymentMethod ?
                            currentSalary?.paymentMethod == 'BANK' ?
                                <span style={{ alignContent: "center", fontSize: "16px" }}>{t("employee.salary.label.bank")}</span> :
                                <span style={{ alignContent: "center", fontSize: "16px" }}>{t("employee.salary.label.cash")}</span>
                            : "-"}
                    </Flex>
                    {currentSalary?.paymentMethod == 'BANK' &&
                        <Flex style={{ rowGap: "16px" }}>
                            <Col span={12}>
                                <Flex vertical={true} style={{ gap: "12px" }}>
                                    <span style={{ fontSize: "16px", color: "#667085" }}>{t('SalarySalary.bank-account')}</span>
                                    <Flex>
                                        {bankGroupType.find(o => o.id === currentSalary?.bankAccount?.id)?.icon && (
                                            <img
                                                src={bankGroupType.find(o => o.id === currentSalary?.bankAccount?.id)?.icon}
                                                alt="Bank icon"
                                                style={{ width: "30px", marginRight: "8px" }}
                                            />
                                        )}
                                        <span style={{ alignContent: "center", fontSize: "16px" }}>
                                            {bankGroupType.find(o => o.id === currentSalary?.bankAccount?.id)?.["name" + (i18n.language == 'en' ? "En" : "")] || "-"}
                                        </span>
                                    </Flex>
                                </Flex>
                            </Col>

                            <Col span={12}>
                                <Flex vertical={true} style={{ gap: "12px" }}>
                                    <span style={{ fontSize: "16px", color: "#667085" }}>{t('SalarySalary..bank-account-no-0')}</span>
                                    <span style={{ fontSize: "16px" }}>{currentSalary.bankAccountNo ? formatBankAccountNo(currentSalary.bankAccountNo, isVisible) : "0.00"}</span>
                                </Flex>
                            </Col>
                        </Flex>
                    }

                    <Flex style={{ rowGap: "16px" }}>
                        <Col span={12}>

                            <Flex vertical={true} style={{ gap: "12px" }}>
                                <span style={{ fontSize: "16px", color: "#667085" }}>{t('SalarySalary..employment-type-0')}</span>
                                <span style={{ fontSize: "16px" }}>
                                    {currentSalary?.employmentType?.["name" + (i18n.language === 'en' ? "En" : "")] || "-"}
                                </span>
                            </Flex>
                        </Col>
                        <Col span={12}>
                            <Flex vertical={true} style={{ gap: "12px" }}>
                                <span style={{ fontSize: "16px", color: "#667085" }}>{t('SalarySalary.salary')}</span>
                                {/* <span style={{ fontSize: "16px" }}>{isVisible ? currentSalary?.salary : "x,xxx.xx"}</span> */}
                                <span style={{ fontSize: "16px" }}>{currentSalary?.salary}</span>
                            </Flex>
                        </Col>
                    </Flex>
                </Flex>
            </Space>
        </Card>
    )
}

export default EmployeeSalaryInfoComponent;